import React from 'react'

export const Desktop = () => {
  return (
    <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />
  )
}
